import {
  Button, Divider, Form, Input, message, Space, Typography,
} from 'antd';
import { AiOutlineMail } from 'react-icons/all';
import React from 'react';
import { useMutation } from '@apollo/client';
import { navigate } from 'gatsby';
import { useLocation } from '@reach/router';
import { REQUEST_PASSWORD_RESET } from '../../../graphql/mutations/requestPasswordReset';
import { formItemLayout } from '../utils/form-item-layout';

const PasswordResetForm = ({ form }) => {
  const { origin } = useLocation();
  const postPasswordResetRequest = async (response) => {
    if (response?.requestPasswordReset.accountErrors.length === 0) {
      message.success('Reset link sent');
      return navigate('/user/auth/reset/');
    }
    response.requestPasswordReset.accountErrors.forEach(
      ((err) => message.error(`${err.message}`)),
    );
    return null;
  };

  const [requestPasswordReset, { loading }] = useMutation(REQUEST_PASSWORD_RESET, {
    errorPolicy: 'all',
    onCompleted: postPasswordResetRequest,
  });

  return (
    <Form
      form={form}
      size="large"
      name="login"
      {...formItemLayout}
      onFinish={(values) => requestPasswordReset({
        variables: {
          email: values.email,
          redirectUrl: `${origin}/user/auth/reset/`,
        },
      })}
    >
      <Form.Item
        name="email"
        label="E-mail"
        rules={[
          {
            type: 'email',
            message: 'The input is not valid E-mail!',
          },
          {
            required: true,
            message: 'Please input your E-mail!',
          },
        ]}
        hasFeedback
      >
        <Input
          prefix={<AiOutlineMail />}
        />
      </Form.Item>
      <Typography>
        You will get an email with a reset link
      </Typography>
      <Divider />
      <Space className="form-actions">
        <Form.Item>
          <Button
            htmlType="submit"
            type="primary"
            loading={loading}
          >
            Reset
          </Button>
        </Form.Item>
      </Space>
    </Form>
  );
};

export default PasswordResetForm;
